import { render } from "./GemMechanism13.vue?vue&type=template&id=0863d8e6&scoped=true"
const script = {}

import "./GemMechanism13.vue?vue&type=style&index=0&id=0863d8e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0863d8e6"]])

export default __exports__